import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Wealth.css';

const Wealth = () => {
  return (
    <>
      <Helmet>
        <title>Wealth - Personal Finance & Investment Strategies | Redbox Global</title>
        <meta name="description" content="Expert insights on wealth management, investing strategies, retirement planning, real estate investment, cryptocurrency, tax optimization, and estate planning for high net worth individuals." />
        <meta name="keywords" content="wealth management, investment strategies, retirement planning, real estate investing, cryptocurrency portfolio, tax optimization, estate planning, personal finance, portfolio diversification, alternative investments" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/wealth" />
        <meta property="og:title" content="Wealth - Personal Finance & Investment Strategies | Redbox Global" />
        <meta property="og:description" content="Expert insights on wealth management, investing strategies, retirement planning, and financial security." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/wealth" />
        <meta name="twitter:title" content="Wealth - Personal Finance & Investment Strategies | Redbox Global" />
        <meta name="twitter:description" content="Expert insights on wealth management, investing strategies, retirement planning, and financial security." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/wealth" />
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Wealth</h1>
        <p className="page-subtitle">Personal finance, investing, and wealth management strategies</p>
      </div>
      
      <div className="page-content">
        <a href="/article/investing-strategies-2026" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=1200&h=600&fit=crop" alt="Wealth management" />
            </div>
            <div className="featured-content">
              
              <h2>Smart Investing Strategies for 2026</h2>
              <p>Navigate market volatility and build long-term wealth with expert insights on portfolio diversification, emerging markets, and alternative investments.</p>
              <span className="article-meta">This Week's Feature</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/retirement-planning-guide" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=600&h=400&fit=crop" alt="Retirement Planning" />
              </div>
              <div className="article-content">
                
                <h2>The Complete Guide to Retirement Planning</h2>
                <p>Expert advice on maximizing your retirement savings and ensuring financial security in your golden years.</p>
                <span className="article-meta">February 3, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/real-estate-investment-trends" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=400&fit=crop" alt="Real Estate" />
              </div>
              <div className="article-content">
              
                <h2>Real Estate Investment Trends to Watch</h2>
                <p>How savvy investors are capitalizing on property markets in a changing economic landscape.</p>
                <span className="article-meta">February 2, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/crypto-portfolio-diversification" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1621761191319-c6fb62004040?w=600&h=400&fit=crop" alt="Cryptocurrency" />
              </div>
              <div className="article-content">
               
                <h2>Crypto Assets in Your Portfolio</h2>
                <p>Should digital currencies be part of your investment strategy? Experts weigh in on risks and opportunities.</p>
                <span className="article-meta">February 1, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/tax-optimization-strategies" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=600&h=400&fit=crop" alt="Tax Planning" />
              </div>
              <div className="article-content">
                
                <h2>Smart Tax Optimization Strategies</h2>
                <p>Legal ways to minimize your tax burden and keep more of your hard-earned wealth.</p>
                <span className="article-meta">January 31, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/high-net-worth-estate-planning" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop" alt="Estate Planning" />
              </div>
              <div className="article-content">
               
                <h2>Estate Planning for High Net Worth Individuals</h2>
                <p>Protecting and transferring wealth across generations with sophisticated planning strategies.</p>
                <span className="article-meta">January 30, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/alternative-investments-guide" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop" alt="Alternative Investments" />
              </div>
              <div className="article-content">
               
                <h2>Beyond Stocks: Alternative Investment Guide</h2>
                <p>Exploring private equity, hedge funds, collectibles, and other alternative asset classes.</p>
                <span className="article-meta">January 29, 2026</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default Wealth;
